/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';


class DescriptionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
    }
  }

  onSubmit = async (e) => {
    e.preventDefault();
    const { success } = this.props;
    success();
  };


  render() {
    const { t, btnSubmitLoading, onBack } =
      this.props;
    const { loadingPage } = this.state;

    if (loadingPage) return true;
    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12  not-information">
                {t('No se encontraron componentes seleccionados')}
            </div>
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />

              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(DescriptionForm);
